import { useTranslation } from "react-i18next";
import { NeuButton, NeuCard, NeuInput, NeuSelect } from "../../components/neu/Neu";

export const PaymentForm = ({ pay, setPay, parties, boxes, onSubmit }) => {
  const { t } = useTranslation();

  return (
    <NeuCard className="grid gap-3 p-5 sm:grid-cols-5" data-testid="payment-form">
      <NeuSelect data-testid="payment-kind" value={pay.kind} onChange={(e) => setPay({ ...pay, kind: e.target.value, party_id: "" })}>
        <option value="supplier_payment">{t("acct.supplierPayment")}</option>
        <option value="customer_receipt">{t("acct.customerReceipt")}</option>
      </NeuSelect>
      <NeuSelect data-testid="payment-party" value={pay.party_id} onChange={(e) => setPay({ ...pay, party_id: e.target.value })}>
        <option value="">{t("acct.party")}</option>
        {parties.map((p) => (
          <option key={p.id} value={p.id}>
            {p.name} ({p.balance})
          </option>
        ))}
      </NeuSelect>
      <NeuSelect data-testid="payment-box" value={pay.cashbox_id} onChange={(e) => setPay({ ...pay, cashbox_id: e.target.value })}>
        <option value="">{t("acct.cashbox")}</option>
        {boxes.map((b) => (
          <option key={b.id} value={b.id}>
            {b.name} ({b.balance})
          </option>
        ))}
      </NeuSelect>
      <NeuInput data-testid="payment-amount" type="number" placeholder={t("acct.amount")} value={pay.amount} onChange={(e) => setPay({ ...pay, amount: e.target.value })} />
      <NeuButton variant="primary" data-testid="payment-save" disabled={!pay.amount} onClick={onSubmit}>
        {t("acct.savePayment")}
      </NeuButton>
    </NeuCard>
  );
};
